"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _CccisdFieldWrapper = _interopRequireDefault(require("../CccisdFieldWrapper"));
var _cccisdDatepicker = _interopRequireDefault(require("cccisd-datepicker"));
var _format = _interopRequireDefault(require("date-fns/format"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var _default = exports["default"] = function _default(props) {
  var field = props.field,
    form = props.form,
    placeholder = props.placeholder,
    showTimeSelect = props.showTimeSelect,
    showMonthYearPicker = props.showMonthYearPicker,
    reactDatepickerProps = props.reactDatepickerProps;
  var onChange = function onChange(date) {
    var value = date ? (0, _format["default"])(date, getDateStringFormat()) : null;
    form.setFieldValue(field.name, value);
  };
  var getDateFormat = function getDateFormat() {
    if (showTimeSelect) {
      return 'MM/dd/yyyy h:mm a';
    }
    if (showMonthYearPicker) {
      return 'MM/yyyy';
    }
    return 'MM/dd/yyyy';
  };
  var getDateStringFormat = function getDateStringFormat() {
    if (showTimeSelect) {
      return 'YYYY-MM-DD HH:mm:ss';
    }
    if (showMonthYearPicker) {
      return 'YYYY-MM';
    }
    return 'YYYY-MM-DD';
  };
  return /*#__PURE__*/_react["default"].createElement(_CccisdFieldWrapper["default"], props, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], _extends({
    className: "form-control input-sm",
    showTimeSelect: showTimeSelect,
    showMonthYearPicker: showMonthYearPicker,
    dateFormat: getDateFormat(),
    placeholderText: placeholder
  }, reactDatepickerProps, {
    selected: field.value,
    onChange: onChange
  }))));
};